import { render, staticRenderFns } from "./DynamicInfo.vue?vue&type=template&id=eff4881e&scoped=true&"
import script from "./DynamicInfo.vue?vue&type=script&lang=ts&"
export * from "./DynamicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicInfo.vue?vue&type=style&index=0&id=eff4881e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff4881e",
  null
  
)

export default component.exports